import React, { useState, useEffect } from 'react'
import { Box, Table, NumberFormatter, Button, Affix, Paper, Text, Flex, Group, Select } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import LoadingData from '../../../../ui/LoadingData'
import NoData from '../../../../ui/NoData'
import { getAllStatusesList } from '../../../../../services/status'
import { updateOrderItemsStatus } from '../../../../../services/orders'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { getOrderItems } from '../../../../../store/orderItems'

const labelTable = [
  {
    label: 'Product Name',
    width: 'auto'
  },
  {
    label: 'Original Price',
    width: 'auto'
  },
  {
    label: 'Qty',
    width: 'auto'
  },
  {
    label: 'Total',
    width: 'auto'
  },
  {
    label: 'Supplier',
    width: 'auto'
  },
  {
    label: 'Cbm',
    width: 'auto'
  },
  {
    label: 'Weight',
    width: 'auto'
  },
  {
    label: '(BM)',
    width: 'auto'
  },
  {
    label: '(PPH)',
    width: 'auto'
  },
  {
    label: '(PPN)',
    width: 'auto'
  },
  {
    label: 'SKU Status',
    width: 270
  },
  {
    label: 'Action',
    width: 150
  },
]

const OrderProductTable = () => {
  const params = useParams()
  const orderId = params.order_id
  const dispatch = useDispatch()
  const { isLoadingOrderItems, dataOrderItems } = useSelector(state => state.order_items)
  const { summary } = useSelector(state => state.order_detail)
  const [dataProductList, setDataProductList] = useState([])
  const [loadingStatus, setLoadingStatus] = useState(true)
  const [statusOrderList, setStatusOrderList] = useState([])
  const [selectedStatus, setSelectedStatus] = useState('22')
  const [loadingForm, setLoadingForm] = useState(false)

  const handleGetOrderStatusList = async () => {
    setLoadingStatus(true)
    const params = {
      'filter[status_type][is]': 4
    }
    try {
      const response = await getAllStatusesList(params)
      const responseData = response.data
      const remapStatus = responseData.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name.charAt(0).toUpperCase() + val.attributes.name.slice(1)
        }
      })
      setStatusOrderList(remapStatus)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatus(false)
    }
  }

  const handleUpdateStatusItems = async (dataProduct) => {
    setLoadingForm(true)
    const findSelectedData = dataProduct.filter((val) => val.selected === true)
    const remapIdProduct = findSelectedData.map((val) => {
      return val.id
    })
    const payload = {
      status_id: Number(selectedStatus),
      items: remapIdProduct
    }
    try {
      const response = await updateOrderItemsStatus(orderId, payload)
      if (response.success) {
        notificationSuccess('Update Status Products Successfully', 'This data has been updated')
        dispatch(getOrderDetail(orderId))
        dispatch(getOrderItems(orderId))
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    handleGetOrderStatusList()
    if (!isLoadingOrderItems) {
      handleSetDataOrderProduct(dataOrderItems)
    }
    // eslint-disable-next-line
  }, [])

  const handleSetDataOrderProduct = (dataProduct) => {
    if (dataProduct.length > 0) {
      const dataProductList = dataProduct.map((item) => {
        return {
          ...item,
          selected: false
        }
      })
      setDataProductList(dataProductList)
    }
  }


  const handleSkuStatus = (skuStatus) => {
    if (skuStatus.length > 0) {
      return skuStatus[0].attributes.name
    } else {
      return 'N/A'
    }
  }

  const handleToggleEditSKU = (idProductItems) => {
    const findData = dataProductList.find((val) => val.id === idProductItems)
    if (findData) {
      const { selected } = findData
      findData.selected = !selected
      setDataProductList([...dataProductList])
    }
  }

  const handleSelectedDataSKU = (dataProduct) => {
    const selectedData = dataProduct.filter((val) => val.selected === true)
    if (selectedData.length > 0) {
      
      const cancelChangeSkuStatus = (dataProduct) => {
        const cancelChangeData = dataProduct.map((val) => {
          return {
            ...val,
            selected: false
          }
        })
        setDataProductList(cancelChangeData)
      }

      return (
        <Affix position={{ bottom: 60, left: 20 }}>
          <Paper shadow="md" withBorder radius='sm' p='md' style={{ borderColor: 'red' }}>
            <Box pos="relative" mb={12}>
              <Select
                name='status'
                value={selectedStatus}
                label='Select SKU Status'
                data={!loadingStatus ? statusOrderList : []}
                onChange={setSelectedStatus}
                size='xs'
                withAsterisk
                allowDeselect={false}
              />
            </Box>
            <Text fz={12}>You have selected <Text span c="blue" inherit fw='600'>{selectedData.length} Product</Text> to change SKU Status</Text>
            <Box mt={20}>
              <Flex justify='flex-end'>
                <Group>
                  <Button size='xs' variant="outline" onClick={() => cancelChangeSkuStatus(dataProductList)}>Cancel</Button>
                  <Button size='xs' loading={loadingForm} variant="filled" disabled={dataProductList.find((val) => val.selected === false)} onClick={() => handleUpdateStatusItems(dataProductList)}>Update</Button>
                </Group>
              </Flex>
            </Box>
          </Paper>
        </Affix>
      )
    }
  }


  const remapTableItems = (dataProduct) => {

    const mappingTableHead = (data) => data.map((val, index) => {
      return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
    })

    const mappingDataTable = (data) => data.map((val, index) => {
      // const showDataPound = (totalProductWeight) => {
      //   const dataTotalWeight = totalProductWeight

      //   const convertDataPound = Number(dataTotalWeight) * 2.20462

      //   return `${convertDataPound.toFixed(3)} pound`
      // } 
      return (
        <Table.Tr key={index}>
        <Table.Td>{val.productName}</Table.Td>
        <Table.Td>
          <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.price} />
        </Table.Td>
        <Table.Td>{val.quantity}</Table.Td>
        <Table.Td>
          <NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={(val.price * val.quantity)} />
        </Table.Td>
        <Table.Td>{val.supplierName ? val.supplierName : '-'}</Table.Td>
        <Table.Td>{val.cbm}</Table.Td>
        <Table.Td>{val.weight} {val.weightUnit}</Table.Td>
        <Table.Td>{val.bm} %</Table.Td>
        <Table.Td>{val.pph} %</Table.Td>
        <Table.Td>{val.ppn} %</Table.Td>
        <Table.Td tt='capitalize'>{val.skuStatus ? handleSkuStatus(val.skuStatus) : 'No Status'}</Table.Td>
        <Table.Td>
          <Button size='compact-xs' fz={10} w={150} color={!val.selected ? 'gray.6' : 'red'} onClick={() => handleToggleEditSKU(val.id)}>{!val.selected ? 'Add to Edit SKU' : 'Remove from Edit SKU'}</Button>
        </Table.Td>
      </Table.Tr>
      )
    })

    return (
      <Table.ScrollContainer minWidth={1366} type='native'>
        <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
          <Table.Thead style={{ backgroundColor: '#eeefef' }}>
            <Table.Tr>
              {mappingTableHead(labelTable)}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody style={{ verticalAlign: 'top' }}>
            {mappingDataTable(dataProduct)}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    )
  }

  return (
    <Box mb={250}>
      {isLoadingOrderItems ? <LoadingData /> : dataProductList.length > 0 ? remapTableItems(dataProductList) : <NoData />}
      {handleSelectedDataSKU(dataProductList)}
    </Box>
  )
}

export default OrderProductTable